import axios from "axios";
import { env } from "../../env";
import { RPC_SOCIAL_PLATFORM_ENDPOINTS } from "../endpoints";

const BASE_URL = env.REACT_APP_CLIENT_API_URL || "";

const normalizePlatform = (item) => {
    const code = item?.SocialMediaCode || item?.SocialMediaName || "";
    return {
        id: item?.Id ?? item?.id,
        name: item?.SocialMediaName || code,
        code,
        key: code.toLowerCase(),
        apiKey: `${code}Account`,
        apiUrlKey: `${code}Url`,
        icon: item?.SocialMediaImageUrl || item?.socialMediaImageUrl || "",
    };
};

export const getSocialPlatformList = async () => {
    const response = await axios.post(`${BASE_URL}${RPC_SOCIAL_PLATFORM_ENDPOINTS.GET_LIST}`, {});
    const raw = response?.data || {};
    const list = Array.isArray(raw) ? raw : (raw?.data || raw?.Data || []);
    return Array.isArray(list) ? list.map(normalizePlatform) : [];
};
